import { connect } from 'react-redux'
import FeedItemEditor from '../components/FeedItemEditor'
import * as FeedItemEditorState from '../modules/feedItemEditor'

export default connect(
  FeedItemEditorState.selectFeedItemEditorState,
  FeedItemEditorState.actionCreators,
)(FeedItemEditor)
